"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.unfollowedArtist = exports.followedArtist = void 0;

var _Schema = require("../../Schema");

/**
 *  A user follows an artist
 *
 * @example
 * ```
 * followedArtist({
 *   contextModule: ContextModule.artistSeriesRail
 *   contextOwnerType: OwnerType.artist,
 *   contextOwnerId: "5359794d2a1e86c3741001f8",
 *   contextOwnerSlug: "andy-warhol",
 *   ownerId: "5359794d1a1e86c3740001f7",
 *   ownerSlug: "sturtevant",
 * })
 * ```
 */
const followedArtist = args => {
  return followArtist(args);
};
/**
 *  A user unfollows an artist
 *
 * @example
 * ```
 * unfollowedArtist({
 *   contextModule: ContextModule.artistSeriesRail
 *   contextOwnerType: OwnerType.artist,
 *   contextOwnerId: "5359794d2a1e86c3741001f8",
 *   contextOwnerSlug: "andy-warhol",
 *   OwnerId: "5359794d1a1e86c3740001f7",
 *   OwnerSlug: "sturtevant",
 * })
 * ```
 */


exports.followedArtist = followedArtist;

const unfollowedArtist = args => {
  return followArtist(args, true);
};

exports.unfollowedArtist = unfollowedArtist;

const followArtist = ({
  contextModule,
  contextOwnerId,
  contextOwnerSlug,
  contextOwnerType,
  ownerId,
  ownerSlug
}, isUnfollow) => {
  let action;

  if (isUnfollow) {
    action = _Schema.ActionType.unfollowedArtist;
  } else {
    action = _Schema.ActionType.followedArtist;
  }

  return {
    action,
    context_module: contextModule,
    context_owner_id: contextOwnerId,
    context_owner_slug: contextOwnerSlug,
    context_owner_type: contextOwnerType,
    owner_id: ownerId,
    owner_slug: ownerSlug,
    owner_type: _Schema.OwnerType.artist
  };
};